import { render, staticRenderFns } from "./BloqueArchivo.vue?vue&type=template&id=2c1c39ba&scoped=true"
import script from "./BloqueArchivo.vue?vue&type=script&lang=js"
export * from "./BloqueArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c39ba",
  null
  
)

export default component.exports